import { styled } from '@mui/material/styles';

export const SharedHeaderDesktopWrapper = styled('div')(({ theme: _theme }) => ({
  position: 'relative',
  '@media (max-width: 1024px)': {
    display: 'none',
  },
  // [theme.breakpoints.down('lg')]: {
  //   display: 'none',
  // },
}));

export const SharedHeaderDesktop = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.primary.dark,
  borderBottom: `4px solid ${theme.palette.gold.medium}`,
  margin: '0 0',
  '@media (max-width: 1024px)': {
    display: 'none',
  },
  // [theme.breakpoints.down('lg')]: {
  //   display: 'none',
  // },
}));

export const SharedHeaderNav = styled('ul')(({
  theme
}) => ({
  //[theme.breakpoints.down('md')]: {
  '@media (max-width: 1024px)': {
    display: 'none',
  },
  [theme.breakpoints.up('md')]: {
    paddingLeft: '1.5rem',
    paddingRight: '1.5rem',
  },
  //[theme.breakpoints.up('lg')]: {
  '@media (min-width: 1024px)': {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'nowrap',
    border: 'none',
    paddingLeft: '2.5rem',
    paddingRight: '2.5rem',
    maxWidth: '1392px',
    margin: '0 auto',
    '& > li': {
      backgroundColor: 'transparent',
      color: '#f1f1f1',
      borderRight: 'thin solid rgba(255, 255, 255, 0.2)',
      '& > a': {
        textDecoration: 'none',
        fontSize: '14px',
        lineHeight: '20px',
        textTransform: 'uppercase',
        textAlign: 'left',
        fontWeight: '600',
        padding: '12px 0.75rem',
        border: 'none',
        display: 'block',
      },
    },
    '& > li:last-child': {
      backgroundColor: 'transparent',
      border: 'none',
      marginLeft: 'auto',
    },
  },
  '& > li a.current-link': {
    backgroundColor: theme.palette.gold.medium,
  },
  '& > li:first-of-type a': {
    display: 'flex',
    alignItems: 'center',
  },
  '& > li:first-of-type a:before': {
    content: '""',
    backgroundImage: `url(${iconUrl})`,
    width: '20px',
    height: '20px',
    backgroundSize: 'cover',
    marginRight: '5px',
    filter: 'brightness(0) invert(1)',
  },
}));

export const SharedHeaderNavMobileTertiary = styled('div')(({ theme }) => ({
  '& > #mobileHelpBtn': {
    backgroundColor: theme.palette.violet.main,
    textAlign: 'center',
    margin: '0 1rem 1rem 1rem',
    '& > a': {
      textDecoration: 'none',
      fontFamily: '"Source Sans 3", sans-serif',
      fontSize: '14px',
      lineHeight: '20px',
      color: theme.palette.common.white,
      textTransform: 'uppercase',
      fontWeight: '600',
      padding: '1rem 1.5rem',
      display: 'block',
    },
  },
}));

export const SearchResultsWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  paddingTop: '2.5rem',
  paddingBottom: '2.5rem',
  overflow: 'auto',
  flexDirection: 'column',
  width: '100%',
  backgroundColor: theme.palette.grey.A100,
  borderBottom: `1px solid ${theme.palette.grey.A400}`,
}));

export const SearchBarWrapper = styled('div')(({ theme: _theme }) => ({
  position: 'absolute',
  top: 70,
  left: 0,
  width: '100%',
  transform: 'translate(0, 48px)',
  zIndex: 400,
}));
